import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { AIQueryKeys } from '../queries'

const useVQAModelsForForm = ({ enabled }: { enabled?: boolean } = {}) => {
  const { aiServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [AIQueryKeys.VQAModelsForForm],
    queryFn: api.vqaModels.getForFormAsync,
    enabled,
  })

  return { loading: query.isLoading, vqaModels: query.data ?? [] }
}

export default useVQAModelsForForm
